import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../app-insights";
import RootPage from "../RootPage";
import localisations from "../../shell/localisation";
import AdjustmentAllocationFeature from "../../features/allocations/adjustment-allocation";
import { useAuth0 } from "@auth0/auth0-react";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";

function AdjustmentAllocationPage() {
    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={localisations.pages.adjustmentAllocation.heading}>
            <AdjustmentAllocationFeature fieldCompanyId={fieldCompanyId} />
        </RootPage>
    );
}

export default withAITracking(reactPlugin, AdjustmentAllocationPage, "Adjustment Allocation Page");
